import { useEffect, useState } from 'react';

/**
 * Sann bare mens den første lastingen pågår (TW 36443150).
 *
 * Lagersjef-tabellene viste en helsides spinner hver gang `loading` var sann. Spinneren erstattet
 * WarehouseTable, så tabellen ble avmontert og kolonnefilter og søk forsvant ved «Oppdater».
 * Brukes i spinner-vakten i stedet for `loading`: etter første lasting blir tabellen stående med
 * filtrene mens nye data hentes.
 */
export function useInitialLoading(loading: boolean): boolean {
  const [hasLoaded, setHasLoaded] = useState(false);

  useEffect(() => {
    if (!loading) setHasLoaded(true);
  }, [loading]);

  return loading && !hasLoaded;
}
